import React from "react"
import {
  eventsItemImg,
  eventsItemDate,
  eventsItemDateFrom,
  eventsItemDateTo,
  eventsItemTaxo,
  eventsItemTitle,
  eventsItemRecurrence,
} from "../agenda.module.scss"
import {
  EventsItemImg,
  Taxo,
  StyledDate,
  EventItemRecurrence,
} from "./evenement-content-styled"
import NonStretchedImage from "../../../Image/non-stretched-image"
import PropTypes from "prop-types"
import TransitionFade from "../../../transition-fade"

const EvenementContent = ({ evenement }) => (
  <>
    <EventsItemImg className={eventsItemImg}>
      {evenement.relationships.field_image_event?.localFile && (
        <TransitionFade arialabel={evenement.title} link={evenement.path.alias}>
          <NonStretchedImage
            {...evenement.relationships.field_image_event.localFile}
            ariaHidden={true}
          />
        </TransitionFade>
      )}
    </EventsItemImg>
    <StyledDate className={eventsItemDate}>
      {!evenement.fields.formatted_field_date_de_fin ? (
        <span className={eventsItemDateFrom}>
          Le {evenement.fields.formatted_field_date_de_debut}
        </span>
      ) : (
        <>
          <span className={eventsItemDateFrom}>
            Du {evenement.fields.formatted_field_date_de_debut}
          </span>
          <span className={eventsItemDateTo}>
            {" "}
            au {evenement.fields.formatted_field_date_de_fin}
          </span>
        </>
      )}
      {evenement.field_evenement_recurrent && (
        <EventItemRecurrence className={eventsItemRecurrence}>
          Récurrent
        </EventItemRecurrence>
      )}
    </StyledDate>
    {evenement.relationships.field_taxonomie_thematique?.length > 0 && (
      <Taxo className={eventsItemTaxo}>
        {evenement.relationships.field_taxonomie_thematique[0].name}
      </Taxo>
    )}
    <h3 className={eventsItemTitle}>
      <TransitionFade link={evenement.path.alias}>
        {evenement.title}
      </TransitionFade>
    </h3>
  </>
)

EvenementContent.propTypes = {
  evenement: PropTypes.object.isRequired,
}

export default EvenementContent
